import angular from 'angular'

angular
  .module('ggs.gallery-load-more')
  .factory('GalleryLoadMoreStyleHandlers', GalleryLoadMoreStyleHandlersProvider)

function GalleryLoadMoreStyleHandlersProvider(rootQs, GSNApplyStyleTmpl) {

  const OWNER_TAG = __filename

  return function GalleryLoadMoreStyleHandlers() {

    // applyColor

    const COLOR_PLH = ':color:'
    const COLOR_TMPL = `
      ${rootQs} .ggs-gallery-load-more__button {
        color:        ${COLOR_PLH};
        border-color: ${COLOR_PLH};
      }`

    const applyColor = GSNApplyStyleTmpl({
      propKeys: 'load_more_button_color',
      ownerTag: OWNER_TAG,
      styleTmpl: COLOR_TMPL,
      stylePlh: COLOR_PLH
    })

    // applyColorHover

    const COLOR_HOVER_PLH = ':color:'
    const COLOR_HOVER_TMPL = `
      ${rootQs} .ggs-gallery-load-more__button:hover .ggs-gallery-load-more__text,
      ${rootQs} .ggs-gallery-load-more__button:focus .ggs-gallery-load-more__text{
        color: ${COLOR_HOVER_PLH};
      }`

    const applyColorHover = GSNApplyStyleTmpl({
      propKeys: 'load_more_button_text_color',
      ownerTag: OWNER_TAG,
      styleTmpl: COLOR_HOVER_TMPL,
      stylePlh: COLOR_HOVER_PLH
    })

    // applyBackgroundHover

    const BACKGROUND_HOVER_PLH = ':color:'
    const BACKGROUND_HOVER_TMPL = `
      ${rootQs} .ggs-gallery-load-more__button:hover,
      ${rootQs} .ggs-gallery-load-more__button:focus {
        background-color: ${BACKGROUND_HOVER_PLH};
      }`

    const applyBackgroundHover = GSNApplyStyleTmpl({
      propKeys: 'load_more_button_color',
      ownerTag: OWNER_TAG,
      styleTmpl: BACKGROUND_HOVER_TMPL,
      stylePlh: BACKGROUND_HOVER_PLH
    })

    // applyRoundCorners

    const ROUND_TMPL = `
      ${rootQs} .ggs-gallery-load-more__button {
        border-radius: 25px;
      }`

    const applyRoundCorners = GSNApplyStyleTmpl({
      propKeys: 'load_more_button_round',
      ownerTag: OWNER_TAG,
      styleFunc: (load_more_button_round) => {
        if (load_more_button_round) {
          return ROUND_TMPL
        }
      }
    })

    // return

    return [
      applyColor,
      applyColorHover,
      applyBackgroundHover,
      applyRoundCorners
    ]
  }
}
